import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { Typography } from "@mui/material";

export const EmptyTransferListView: FC<IEmptyTransferListViewProps> = ({
  message,
  minHeight = 300,
}) => {
  const { classes } = useStyles({ minHeight });
  return (
    <div className={classes.container}>
      <Typography
        variant={TYPOGRAPHY_VARIANTS.BD1}
        className={classes.message}
        color="primary.main"
      >
        {message}
      </Typography>
    </div>
  );
};

interface IEmptyTransferListViewProps {
  message: string | React.ReactNode;
  minHeight?: number;
}

const useStyles = makeStyles<{ minHeight?: number }>()(
  (theme, { minHeight }) => ({
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(2),
      flex: 1,
      backgroundColor: theme.palette.primary.light,
      height: "100%",
      borderRadius: theme.spacing(2),
      minHeight,
    },
    message: {
      textAlign: "center",
      padding: theme.spacing(4),
      color: theme.palette.primary.main,
      fontSize: theme.typography.body1.fontSize,
    },
  })
);
